import Enumeration from 'Lib/utilities/Enumeration';

const ObjectTypes = new Enumeration([
	{ id: 1, key: 'Account', name: 'Account' },
	{ id: 2, key: 'User', name: 'User' },
	{ id: 3, key: 'Contact', name: 'Contact' },
	{ id: 4, key: 'Lease', name: 'Lease' },
	{ id: 5, key: 'Bill', name: 'Bill' },
	{ id: 6, key: 'Property', name: 'Property' },
	{ id: 7, key: 'Unit', name: 'Unit' },
	{ id: 8, key: 'Deposit', name: 'Deposit' },
	{ id: 9, key: 'AccountingTransaction', name: 'Accounting Transaction' },
	{ id: 10, key: 'AccountingTransactionEntry', name: 'Accounting Transaction Entry' },
	{ id: 11, key: 'Portfolio', name: 'Portfolio' },
	{ id: 12, key: 'Payout', name: 'Payout' },
	{ id: 13, key: 'BankAdjustment', name: 'Bank Adjustment' },
	{ id: 14, key: 'Company', name: 'Company' },
	{ id: 15, key: 'Statement', name: 'Statement' },
	{ id: 16, key: 'WorkOrder', name: 'Work Order' },
	{ id: 17, key: 'Inspection', name: 'Inspection' },
	{ id: 18, key: 'InspectionArea', name: 'InspectionArea' },
	{ id: 19, key: 'InspectionItem', name: 'InspectionItem' },
	{ id: 20, key: 'Application', name: 'Application' },
	{ id: 21, key: 'Applicant', name: 'Applicant' },
	{ id: 22, key: 'BankTransfer', name: 'BankTransfer' },
	{ id: 23, key: 'Listing', name: 'Listing' },
	{ id: 24, key: 'Appliance', name: 'Appliance' },
	{ id: 25, key: 'TextMessage', name: 'Text Message' },
	{ id: 26, key: 'EmailMessage', name: 'Email Message' },
	{ id: 27, key: 'WorkOrderEstimate', name: 'Work Order Estimate' },
	{ id: 28, key: 'Settlement', name: 'Settlement' },
	{ id: 29, key: 'LeaseTenant', name: 'Lease Tenant' },
	{ id: 30, key: 'EmailTemplate', name: 'Email Template' },
	{ id: 31, key: 'Note', name: 'Note' },
	{ id: 32, key: 'FileAttachment', name: 'File Attachment' },
	{ id: 33, key: 'Invoice', name: 'Invoice' },
	{ id: 34, key: 'DocumentTransaction', name: 'Document Transaction' },
	{ id: 35, key: 'DocumentEnvelope', name: 'Document Envelope' },
	{ id: 36, key: 'ApplicationTemplate', name: 'Application Template' },
	{ id: 37, key: 'RecurringBill', name: 'Recurring Bill' },
	{ id: 38, key: 'ChatMessage', name: 'Chat Message' },
	{ id: 39, key: 'Reconciliation', name: 'Reconciliation' },
	{ id: 40, key: 'Path', name: 'Path' },
	{ id: 41, key: 'PayoutReturn', name: 'Payout Return' },
	{ id: 42, key: 'ManagementFeeSetting', name: 'Management Fee Setting' },
	{ id: 43, key: 'AdditionalManagementFeeSetting', name: 'Additional Management Fee Setting' },
	{ id: 44, key: 'AccountingSetting', name: 'Accounting Setting' },
	{ id: 45, key: 'PostingSetting', name: 'Posting Setting' },
	{ id: 46, key: 'LateFeeSetting', name: 'Late Fee Setting' },
	{ id: 47, key: 'StatementSetting', name: 'Statement Setting' },
	{ id: 48, key: 'PayoutBatch', name: 'Payment Batch' },
	{ id: 49, key: 'Letter', name: 'Letter' },
	{ id: 50, key: 'Reminder', name: 'Reminder' },
	{ id: 51, key: 'Review', name: 'Review' },
	{ id: 52, key: 'LandlordVerification', name: 'Landlord Verification' },
	{ id: 53, key: 'RentIncrease', name: 'Rent Increase' },
	{ id: 54, key: 'AccountingAccount', name: 'Accounting Account' },
	{ id: 55, key: 'LeaseChargeNotification', name: 'Lease Charge Notification' },
	{ id: 56, key: 'StartedApplication', name: 'Started Application' },
	{ id: 57, key: 'SavedReport', name: 'Saved Report' },
	{ id: 58, key: 'Tag', name: 'Tag' },
	{ id: 59, key: 'TagObject', name: 'Tag Object' },
	{ id: 60, key: 'ContactPhone', name: 'Contact Phone' },
	{ id: 61, key: 'ContactEmail', name: 'Contact Email' },
	{ id: 62, key: 'ContactAddress', name: 'Contact Address' },
	{ id: 63, key: 'VendorType', name: 'Vendor Type' },
	{ id: 64, key: 'VendorTrade', name: 'Vendor Trade' },
	{ id: 65, key: 'ContactVendorTrade', name: 'Contact Vendor Trade' },
	{ id: 66, key: 'PortfolioOwner', name: 'Portfolio Owner' },
	{ id: 67, key: 'PropertyAssociation', name: 'Property Association' },
	{ id: 68, key: 'Occupant', name: 'Occupant' },
	{ id: 69, key: 'Vehicle', name: 'Vehicle' },
	{ id: 70, key: 'EmergencyContact', name: 'Emergency Contact' },
	{ id: 71, key: 'PropertyFeature', name: 'Property Feature' },
	{ id: 72, key: 'PropertyCustomFeature', name: 'Property Custom Feature' },
	{ id: 73, key: 'PropertyPortfolio', name: 'Property Portfolio' },
	{ id: 74, key: 'WorkOrderProject', name: 'Work Order Project' },
	{ id: 75, key: 'Ledger', name: 'Ledger' },
	{ id: 76, key: 'PortfolioGroup', name: 'Portfolio Group' },
	{ id: 77, key: 'ScreeningReport', name: 'Screening Report' },
	{ id: 78, key: 'ScreeningReportDocument', name: 'Screening Report Document' },
	{ id: 79, key: 'ScreeningProspect', name: 'ScreeningProspect' }
]);

export default ObjectTypes;
